import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...a }, /* @__PURE__ */ e.createElement(
  "path",
  {
    className: "warning-2_svg__puchipuchi_een",
    d: "M30.211 23.98L17.798 3.034c-.81-1.366-2.787-1.366-3.596 0L1.789 23.98C.999 25.314 1.96 27 3.51 27h24.98c1.55 0 2.511-1.686 1.721-3.02zM16 24a2 2 0 11-.001-3.999A2 2 0 0116 24zm2-10.623a9.991 9.991 0 01-.513 3.162l-.171.512a1.387 1.387 0 01-2.632 0l-.171-.512A9.991 9.991 0 0114 13.377v-2.99C14 9.621 14.621 9 15.387 9h1.225C17.379 9 18 9.621 18 10.387v2.99z",
    fill: "#111918"
  }
)), n = t;
export {
  n as default
};
